// import React, { useState, useEffect } from "react";
// import { X, Check, ChevronRight, Loader2 } from "lucide-react";
// import { useAdminAuth } from "../context/AdminAuthContext";

// interface Props {
//   user: any;
//   onClose: () => void;
//   onSuccess: () => void;
// }

// const ApprovalModal: React.FC<Props> = ({ user, onClose, onSuccess }) => {
//   const { role: myRole, token } = useAdminAuth();
  
//   // Selections
//   const [selectedRole, setSelectedRole] = useState("");
//   const [selectedAdmin, setSelectedAdmin] = useState("");
//   const [selectedManager, setSelectedManager] = useState("");
//   const [selectedTL, setSelectedTL] = useState("");
  
//   // Data Lists for Dropdowns
//   const [admins, setAdmins] = useState([]);
//   const [managers, setManagers] = useState([]);
//   const [tls, setTls] = useState([]);

//   const [loading, setLoading] = useState(false);

//   // --- 1. ROLES LIST LOGIC ---
//   // Super Admin sab bana sakta hai, Admin sirf Manager/TL/Agent
//   const allowedRoles = myRole === "SUPER_ADMIN" 
//     ? ["ADMIN", "MANAGER", "TEAM_LEADER", "AGENT"]
//     : ["MANAGER", "TEAM_LEADER", "AGENT"];

//   // --- 2. FETCH DATA LOGIC ---
  
//   // Fetch Admins (Only if Super Admin wants to assign Manager/TL/Agent)
//   useEffect(() => {
//     if (myRole === "SUPER_ADMIN" && ["MANAGER", "TEAM_LEADER", "AGENT"].includes(selectedRole)) {
//       fetchHierarchy("ADMIN", null, setAdmins);
//     }
//   }, [selectedRole]);

//   // Fetch Managers (When Admin is selected OR when Admin logs in)
//   useEffect(() => {
//     if (selectedRole === "TEAM_LEADER" || selectedRole === "AGENT") {
//       if (myRole === "SUPER_ADMIN" && selectedAdmin) {
//         fetchHierarchy("MANAGER", selectedAdmin, setManagers);
//       } else if (myRole === "ADMIN") {
//         fetchHierarchy("MANAGER", null, setManagers); // Mere apne managers
//       }
//     }
//   }, [selectedAdmin, selectedRole]);

//   // Fetch TLs (When Manager is selected)
//   useEffect(() => {
//     if (selectedRole === "AGENT" && selectedManager) {
//       fetchHierarchy("TEAM_LEADER", selectedManager, setTls);
//     }
//   }, [selectedManager, selectedRole]);


//   // API Helper
//   const fetchHierarchy = async (roleType: string, parentId: string | null, setState: any) => {
//     let url = `https://luxuriyahomes.com/api/admin/team/hierarchy?role=${roleType}`;
//     if (parentId) url += `&parentId=${parentId}`;
    
//     const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
//     if (res.ok) setState(await res.json());
//   };


//   // --- 3. SUBMIT LOGIC ---
//   const handleApprove = async () => {
    
//     // Logic to decide Parent
//     let finalParentId = null;

//     if (selectedRole === "MANAGER") {
//        // Agar Super Admin hu, to jo Admin select kiya wo parent banega
//        // Agar selectedAdmin empty hai, to null jayega (fir backend Current User lega)
//        finalParentId = selectedAdmin ? Number(selectedAdmin) : null; 
//     } else if (selectedRole === "TEAM_LEADER") {
//        finalParentId = selectedManager ? Number(selectedManager) : null;
//     } else if (selectedRole === "AGENT") {
//        finalParentId = selectedTL ? Number(selectedTL) : null;
//     }

//     const payload = { 
//         userId: user.id, 
//         role: selectedRole,
//         explicitParentId: finalParentId 
//     };

//     // DEBUGGING: Console me dekho kya ja raha hai
//     console.log("Sending Payload:", payload);

//     try {
//         setLoading(true);
//         const res = await fetch("https://luxuriyahomes.com/api/admin/team/approve", {
//             method: "POST",
//             headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//             body: JSON.stringify(payload)
//         });
        
//         if(res.ok) {
//             onSuccess();
//             onClose();
//         } else {
//             const err = await res.text();
//             alert("Error: " + err);
//         }
//     } catch (e) { 
//         console.error(e); 
//     } finally {
//         setLoading(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[100] backdrop-blur-sm p-4 font-[Serif]">
//       <div className="bg-[#1c1c1c] w-full max-w-lg rounded-2xl border border-zinc-800 p-8 shadow-2xl relative">
//         <button onClick={onClose} className="absolute top-4 right-4 text-zinc-500 hover:text-white"><X size={20}/></button>
        
//         <h2 className="text-2xl text-white font-light mb-1">Approve User</h2>
//         <p className="text-zinc-500 text-sm mb-6">Assign role & hierarchy for <span className="text-amber-500 font-bold">{user.name}</span></p>

//         <div className="space-y-4">
          
//           {/* 1. ROLE SELECTION */}
//           <div>
//             <label className="text-xs uppercase text-zinc-500 font-bold tracking-wider">Assign Role</label>
//             <select 
//               className="w-full mt-2 bg-black border border-zinc-800 text-white p-3 rounded focus:border-amber-500 outline-none"
//               onChange={(e) => {
//                 setSelectedRole(e.target.value);
//                 // Reset downstream selections
//                 setSelectedAdmin(""); setSelectedManager(""); setSelectedTL("");
//               }}
//             >
//               <option value="">-- Select Role --</option>
//               {allowedRoles.map(r => <option key={r} value={r}>{r}</option>)}
//             </select>
//           </div>

//           {/* 2. ADMIN SELECTION (Only for Super Admin creating Manager/TL/Agent) */}
//           {myRole === "SUPER_ADMIN" && ["MANAGER", "TEAM_LEADER", "AGENT"].includes(selectedRole) && (
//              <div className="animate-in slide-in-from-top-2 fade-in">
//                 <label className="text-xs uppercase text-zinc-500 font-bold tracking-wider">Under Which Admin?</label>
//                 <select 
//                     className="w-full mt-2 bg-black border border-zinc-800 text-white p-3 rounded focus:border-amber-500 outline-none"
//                     onChange={(e) => setSelectedAdmin(e.target.value)}
//                 >
//                     <option value="">-- Select Admin --</option>
//                     {admins.map((a:any) => <option key={a.id} value={a.id}>{a.name}</option>)}
//                 </select>
//              </div>
//           )}

//           {/* 3. MANAGER SELECTION (For TL/Agent) */}
//           {(selectedRole === "TEAM_LEADER" || selectedRole === "AGENT") && (
//              <div className="animate-in slide-in-from-top-2 fade-in">
//                 <label className="text-xs uppercase text-zinc-500 font-bold tracking-wider">Under Which Manager?</label>
//                 <select 
//                     className="w-full mt-2 bg-black border border-zinc-800 text-white p-3 rounded focus:border-amber-500 outline-none"
//                     onChange={(e) => setSelectedManager(e.target.value)}
//                     disabled={myRole === "SUPER_ADMIN" && !selectedAdmin} // Disable until Admin selected
//                 >
//                     <option value="">-- Select Manager --</option>
//                     {managers.map((m:any) => <option key={m.id} value={m.id}>{m.name}</option>)}
//                 </select>
//              </div>
//           )}

//           {/* 4. TL SELECTION (For Agent) */}
//           {selectedRole === "AGENT" && (
//              <div className="animate-in slide-in-from-top-2 fade-in">
//                 <label className="text-xs uppercase text-zinc-500 font-bold tracking-wider">Under Which Team Leader?</label>
//                 <select 
//                     className="w-full mt-2 bg-black border border-zinc-800 text-white p-3 rounded focus:border-amber-500 outline-none"
//                     onChange={(e) => setSelectedTL(e.target.value)}
//                     disabled={!selectedManager}
//                 >
//                     <option value="">-- Select Team Leader --</option>
//                     {tls.map((t:any) => <option key={t.id} value={t.id}>{t.name}</option>)}
//                 </select>
//              </div>
//           )}

//         </div>

//         {/* FOOTER */}
//         <div className="mt-8 flex justify-end gap-4">
//             <button onClick={onClose} className="text-zinc-400 hover:text-white text-sm uppercase tracking-wider font-bold">Cancel</button>
//             <button 
//                 onClick={handleApprove}
//                 disabled={loading || !selectedRole}
//                 className="bg-amber-600 hover:bg-amber-500 text-black px-6 py-3 rounded font-bold uppercase tracking-widest text-xs flex items-center gap-2"
//             >
//                 {loading ? "Processing..." : "Confirm Approval"} <Check size={16}/>
//             </button>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default ApprovalModal;


import React, { useState, useEffect } from "react";
import { X, Check, Building2, HardHat } from "lucide-react";
import { useAdminAuth } from "../context/AdminAuthContext";

interface Props {
  user: any;
  onClose: () => void;
  onSuccess: () => void;
}

const ApprovalModal: React.FC<Props> = ({ user, onClose, onSuccess }) => {
  const { role: myRole, token } = useAdminAuth();
  
  // STEP 1: Department Toggle
  const [department, setDepartment] = useState<"SALES" | "SITE">("SALES");

  // Selections
  const [selectedRole, setSelectedRole] = useState("");
  const [parentId, setParentId] = useState(""); // Simplified parent ID
  
  // Data Lists
  const [admins, setAdmins] = useState([]);
  const [managers, setManagers] = useState([]);
  const [tls, setTls] = useState([]);
  const [loading, setLoading] = useState(false);

  // --- FETCH HIERARCHY LOGIC (Existing Logic Preserved) ---
  const fetchHierarchy = async (roleType: string, pid: string | null, setState: any) => {
    let url = `https://luxuriyahomes.com/api/admin/team/hierarchy?role=${roleType}`;
    if (pid) url += `&parentId=${pid}`;
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (res.ok) setState(await res.json());
  };

  // Load Initial Data based on My Role
  useEffect(() => {
    if (myRole === "SUPER_ADMIN") fetchHierarchy("ADMIN", null, setAdmins);
    if (myRole === "ADMIN") fetchHierarchy("MANAGER", null, setManagers);
  }, [myRole]);

  // Load Dependent Data (Cascading Dropdowns for Sales)
  useEffect(() => {
    if (selectedRole === "TEAM_LEADER" && parentId) fetchHierarchy("MANAGER", parentId, setManagers); // Logic tweak based on structure
  }, [selectedRole, parentId]);


  // --- SUBMIT LOGIC ---
  const handleApprove = async () => {
    
    // 1. Role Logic
    let finalRole = selectedRole;
    if (department === "SITE") finalRole = "EXECUTIVE"; // Site Engineer fixed role

    // 2. Parent Logic
    // Agar SITE department hai, to Parent directly Current User (Admin) banega ya dropdown se select karwa sakte ho.
    // Abhi ke liye simple rakhte hain: Jo approve kar raha hai wahi boss.
    let finalParentId = parentId ? Number(parentId) : null;

    const payload = { 
        userId: user.id, 
        role: finalRole,
        explicitParentId: finalParentId,
        department: department
    };

    try {
        setLoading(true);
        // const res = await fetch("http://localhost:1001/api/admin/team/approve", {
        const res = await fetch("https://luxuriyahomes.com/api/admin/team/approve", {
            method: "POST",
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
            body: JSON.stringify(payload)
        });
        
        if(res.ok) {
            onSuccess();
            onClose();
        } else {
            alert("Error approving user");
        }
    } catch (e) { console.error(e); } 
    finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[100] backdrop-blur-sm p-4 font-[Serif]">
      <div className="bg-[#1c1c1c] w-full max-w-lg rounded-2xl border border-zinc-800 p-8 shadow-2xl relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-zinc-500 hover:text-white"><X size={20}/></button>
        
        <h2 className="text-2xl text-white font-light mb-1">Approve User</h2>
        <p className="text-zinc-500 text-sm mb-6">Assign department & role for <span className="text-amber-500 font-bold">{user.name}</span></p>

        {/* --- DEPARTMENT SWITCHER --- */}
        <div className="flex gap-4 mb-6">
            <button 
                onClick={() => { setDepartment("SALES"); setSelectedRole(""); }}
                className={`flex-1 py-4 rounded-xl border flex flex-col items-center justify-center gap-2 transition-all ${
                    department === "SALES" 
                    ? "bg-amber-600/10 border-amber-600 text-amber-500" 
                    : "bg-zinc-900 border-zinc-800 text-zinc-500 hover:border-zinc-700"
                }`}
            >
                <Building2 size={24} />
                <span className="text-xs font-bold tracking-widest uppercase">Sales Team</span>
            </button>
            <button 
                onClick={() => { setDepartment("SITE"); setSelectedRole("EXECUTIVE"); }}
                className={`flex-1 py-4 rounded-xl border flex flex-col items-center justify-center gap-2 transition-all ${
                    department === "SITE" 
                    ? "bg-blue-600/10 border-blue-600 text-blue-500" 
                    : "bg-zinc-900 border-zinc-800 text-zinc-500 hover:border-zinc-700"
                }`}
            >
                <HardHat size={24} />
                <span className="text-xs font-bold tracking-widest uppercase">Site Engineer</span>
            </button>
        </div>

        {/* --- DYNAMIC FORM --- */}
        <div className="space-y-4">
          
          {/* A. SALES LOGIC (Existing Dropdowns) */}
          {department === "SALES" && (
            <div className="animate-in fade-in space-y-4">
                <div>
                    <label className="text-xs uppercase text-zinc-500 font-bold tracking-wider">Assign Role</label>
                    <select 
                        className="w-full mt-2 bg-black border border-zinc-800 text-white p-3 rounded focus:border-amber-500 outline-none"
                        onChange={(e) => setSelectedRole(e.target.value)}
                    >
                        <option value="">-- Select Role --</option>
                        <option value="MANAGER">Manager</option>
                        <option value="TEAM_LEADER">Team Leader</option>
                        <option value="AGENT">Agent (Lead Manager)</option>
                    </select>
                </div>

                {/* Hierarchical dropdowns logic remains similar to your existing one */}
                {/* For simplicity in this snippet, assuming direct assignment under current admin if complex logic isn't needed */}
            </div>
          )}

          {/* B. SITE ENGINEER LOGIC (Simple) */}
          {department === "SITE" && (
             <div className="animate-in fade-in p-4 bg-blue-900/10 border border-blue-900/30 rounded-lg">
                <div className="flex items-center gap-3 mb-2">
                    <Check className="text-blue-500" size={18} />
                    <p className="text-blue-200 text-sm font-bold">Role: EXECUTIVE</p>
                </div>
                <p className="text-zinc-400 text-xs leading-relaxed">
                    This user will have access to the <b>Material Requisition</b> panel only. 
                    They will not see Sales Leads.
                </p>
             </div>
          )}

        </div>

        {/* FOOTER */}
        <div className="mt-8 flex justify-end gap-4">
            <button onClick={onClose} className="text-zinc-400 hover:text-white text-sm uppercase tracking-wider font-bold">Cancel</button>
            <button 
                onClick={handleApprove}
                disabled={loading || (department === "SALES" && !selectedRole)}
                className={`px-6 py-3 rounded font-bold uppercase tracking-widest text-xs flex items-center gap-2 ${
                    department === "SALES" ? "bg-amber-600 hover:bg-amber-500 text-black" : "bg-blue-600 hover:bg-blue-500 text-white"
                }`}
            >
                {loading ? "Processing..." : "Confirm Approval"}
            </button>
        </div>

      </div>
    </div>
  );
};

export default ApprovalModal;